@if (item().entityNumber; as entityNumber) {
  <div class="badge">
    @if (showDetail()) {
      <mat-icon
        class="info"
        matDetail="Show info"
        (click)="toggleDetail()"
      >
        {{ isDetailVisible() ? "expand_more" : "chevron_right" }}
      </mat-icon>
    }
    <procure-search-entity-badge
      [label]="entityNumber"
      [index]="index()"
      [item]="item()"
    />
  </div>
  @if (item().name; as name) {
    <div class="entity">
      <a
        class="link"
        [routerLink]="link()"
        (click)="clickLink()"
      >
        {{ name }}
      </a>
      <search-result-highlights [highlights]="highlights()" />
    </div>
  }
}
@if (item().status; as status) {
  <div class="status">
    <procure-status-badge [status]="status" />
  </div>
}
@if (isDetailVisible()) {
  <procure-search-result-detail
    class="detail"
    [item]="item()"
  />
}
